import throttle from "lodash/throttle";
import { RefObject, useEffect } from "react";

export function useRowEqualHeights(
  rootRef: RefObject<HTMLElement>,
  targetClass: string,
  disabled = false,
  ignoreChildClassName?: string
) {
  useEffect(() => {
    const root = rootRef.current;
    if (disabled || !root) {
      return;
    }

    const equalise = throttle(() => {
      const cards = Array.from(
        root.querySelectorAll<HTMLElement>(`.${targetClass}`)
      );
      if (cards.length < 2) {
        return;
      }

      cards.forEach((el) => (el.style.minHeight = ""));
      const maxHeight = Math.max(
        ...cards.map((c) => {
          let correction = 0;
          if (ignoreChildClassName) {
            const maxChildHeight = Math.max(
              ...Array.from(c.querySelectorAll(`.${ignoreChildClassName}`)).map(
                (e) => e.getBoundingClientRect().height
              ),
              0
            );
            correction -= maxChildHeight;
          }

          return c.getBoundingClientRect().height + correction;
        })
      );
      cards.forEach((el) => (el.style.minHeight = `${maxHeight}px`));
    }, 16);

    equalise();
    window.addEventListener("resize", equalise);
    return () => window.removeEventListener("resize", equalise);
  }, [rootRef, targetClass, disabled, ignoreChildClassName]);
}
